import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import ReactHabitat from "react-habitat";

class App extends ReactHabitat.Bootstrapper {
  constructor() {
    super();

    // Create a new container builder:
    const builder = new ReactHabitat.ContainerBuilder();

    // Register a component:
    // builder.register(ThreeImg).as('ThreeImg');

    // Or register a component to load on demand asynchronously:
    builder
      .registerAsync(() =>
        import(/* webpackChunkName: "FAQ" */ "./components/FAQ/FAQ")
      )
      .as("FAQ");
    builder
      .registerAsync(() =>
        import(/* webpackChunkName: "GetCare" */ "./components/GetCare/GetCare")
      )
      .as("GetCare");
    builder
      .registerAsync(() =>
        import(/* webpackChunkName: "FaqCms" */ "./components/FAQ_V2/FaqCms")
      )
      .as("FaqCms");
    builder
      .registerAsync(() =>
        import(
          /* webpackChunkName: "Checklist" */ "./components/Checklist/Checklist"
        )
      )
      .as("Checklist");
    builder
      .registerAsync(() =>
        import(
          /* webpackChunkName: "ThreeImg" */ "./components/ThreeImg/ThreeImg"
        )
      )
      .as("ThreeImg");
    builder
      .registerAsync(() =>
        import(/* webpackChunkName: "VisitWidget" */ "./components/VisitWidget/VisitWidget")
      )
      .as("VisitWidget");
    builder
      .registerAsync(() =>
        import(
          /* webpackChunkName: "VideoPlayer" */ "./components/VideoPlayer/VideoPlayer"
        )
      )
      .as("VideoPlayer");
    builder
      .registerAsync(() =>
        import(/* webpackChunkName: "Promo" */ "./components/Promo/Promo")
      )
      .as("CmsPromo");
    builder
      .registerAsync(() =>
        import(
          /* webpackChunkName: "CampaignPromo" */ "./components/CampaignPromo/CampaignPromo"
        )
      )
      .as('CampaignPromo');
    builder
      .registerAsync(() =>
        import(/* webpackChunkName: "AlertBox" */ "./components/AlertBox"
        )
      )
      .as("AlertBox");
    builder
      .registerAsync(() =>
        import(/* webpackChunkName: "LocationBox" */ "./components/LocationBox"
        )
      )
      .as("LocationBox");

    // Finally, set the container:
    this.setContainer(builder.build());
  }
}
// Always export a 'new' instance so it immediately evokes:
export default new App();
